<template>
    <div class="h-50 mb-12 flex w-full animate-pulse flex-col">
        <div class="aspect-square border border-neutral-300 bg-neutral-200" />
        <div class="mt-2 h-3 w-3/5 bg-neutral-300" />
        <div class="mt-2 h-4 w-4/5 bg-neutral-400" />
        <div class="mt-4 h-3 w-2/5 bg-neutral-300" />
        <div class="mt-6 h-3 w-full bg-neutral-300" />
        <div class="mt-2 h-3 w-full bg-neutral-300" />
        <div class="mt-2 h-3 w-3/5 bg-neutral-300" />
    </div>
</template>
